import { Badge, FormHelperText, Grid, Menu, MenuItem, TextField } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
	LoadOrgName,
	//  LoadProfile,
	UpdateMenuFlag
} from "../../actions";
import Config from "../../config";
import { setHeaderTitle } from "../../helpers/header.helper";
import { ProfileModel, mapToProfile } from "../../models/profile.model";
import { Role } from "../../models/roles.model";
import { UserService } from "../../services/UserService";
import { UtilityService } from "../../services/UtilityService";
import Avatar from "../shared/avatar.component";
import ButtonComponent from "../shared/button/button.component";
import { ActionLabels, appNote, pageTitles, RolesLabel, ToasterTexts } from "../shared/constants";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import AvatarAminationData from "../shared/loaders/profile-avatar-loader.json";
import ProfileTextboxLoader from "../shared/loaders/textbox-loader.json";
import PageHeader from "../shared/page-header.component";
import EditProfile from "./edit-profile.component";
import PullToRefresh from 'react-simple-pull-to-refresh';
import { BackMobileIcon, ChangeProfileIcon, EditProfileIcon, ProfileCameraIcon, RemoveIcon, RemovePhotoIcon, UploadIcon } from "../../icon";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import { useDispatch } from 'react-redux';
import { ChannelUserModel } from "../../models/users.model";
import { ChannelUserService } from "../../services/ChannelUserService";
import { validateForm } from "../shared/form-validation";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import { useLocation } from "react-router";
import { mapToOnboardingDetailsModel, OnboardingDetailsModel } from "../../models/dashboard.model";
import { updateOnBoardingDetails } from "../../reducers/reducer";
import { trimMessage } from "../../services/MessageComposerServices";


interface Props {

}

const ProfileComponent = (props: Props) => {
	const dispatch = useDispatch()
	const location = useLocation();

	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
	// const Profile: ProfileModel = UserService.getCurrentUserFromLocalStorage()
	const [Profile, setProfile] = useState<ChannelUserModel>(ChannelUserService.getCurrentUserFromLocalStorage())
	const OrgName = useSelector(selector.OrganizationName);
	const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
	const LoadingProfile: boolean = useSelector(selector.loadingProfile)
	const [showEditProfile, setShowEditProfile] = useState<boolean>(false)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [errors, setErrors] = useState({
		FirstName: "",
		LastName: "",
		Organization: "",
	});
	const [firstName, setFirstName] = useState(Profile.FirstName);
	const [lastName, setLastName] = useState(Profile.LastName);
	const [organization, setOrganization] = useState(Profile.OrganizationName);
	const [file, setFile] = useState("");
	const [hasError, setHasError] = useState("");
	const [anchorEl, setAnchorEl] = useState(null);
	const [image, setImage] = useState(Profile.ImageReferenceId);
	const [imageReferenceId, setImageReferenceId] = useState(Profile.ImageReferenceId);
	const OnboardingDetails: OnboardingDetailsModel = useSelector(selector.OnboardingDetails);

	useEffect(() => {
		if (location?.state) {
			setShowEditProfile(true);
		}
	}, [location?.state])

	useEffect(() => {
		setHeaderTitle(pageTitles.PROFILE)
	}, [])

	const handleClickmenu = (event: any) => {
		event.preventDefault();
		setAnchorEl(event.target)
	};
	const handleClosemenu = () => {
		setAnchorEl(null)
	};

	const onImagechange = (e: any) => {
		let file = e.target.files[0];
		if (file !== undefined) {
			let Url = URL.createObjectURL(file);
			var pattern = /image-*/;
			if (!file.type.match(pattern)) {
				setHasError("Please upload photo of only allowed file types")
				setAnchorEl(null)
				return;
			}
			else if (file.size > Config.IMAGE_MAX_SIZE) {
				setHasError("File size should be less than 100 KB")
				setAnchorEl(null)
			}
			else if (file.size <= Config.IMAGE_MIN_SIZE) {
				setHasError("File size should be more than 20 KB")
				setAnchorEl(null)
			}
			else {

				setImage(Url)
				setFile(file)
				setAnchorEl(null)
				setHasError("")
			}
		}
	}
	const onRemovephoto = () => {
		setImage(null)
		setFile("")
		setAnchorEl(null)
		setHasError("")
	};

	const handleChange = (name: any, value: any) => {
		validateForm({ [name]: value }, (Errors) => {
			setErrors({ ...errors, ...Errors })
		});
	};

	const handleOpenEditProfile = () => {
		setShowEditProfile(true)
		setHeaderTitle(pageTitles.EDIT_PROFILE)
	};

	const fileInputRef = useRef<HTMLInputElement>()

	const handleCloseEditProfile = (flag: boolean) => {
		setShowEditProfile(false)
		setHeaderTitle(pageTitles.PROFILE);
		setImage(Profile.ImageReferenceId ? Profile.ImageReferenceId : "")
		setErrors({ ...errors, FirstName: "", LastName: "", Organization: "" })
		setHasError("")
		setFirstName(Profile.FirstName)
		setLastName(Profile.LastName)
		setOrganization(Profile.OrganizationName)
		setImage(Profile.ImageReferenceId)
		if (flag || !Profile?.IsProfileUpdated) {
			ChannelUserService.getCurrentUser(Profile.Email).then((res) => {
				setProfile(ChannelUserService.getCurrentUserFromLocalStorage())
				setFirstName(ChannelUserService.getCurrentUserFromLocalStorage().FirstName)
				setLastName(ChannelUserService.getCurrentUserFromLocalStorage().LastName)
				setOrganization(ChannelUserService.getCurrentUserFromLocalStorage().OrganizationName)
				setImage(ChannelUserService.getCurrentUserFromLocalStorage().ImageReferenceId)
			}).catch((err) => {

			})
		}
	};

	const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => ChannelUserService.getCurrentUserFromLocalStorage());

	const onSubmit = (event: any) => {
		event.preventDefault();
		if (
			validateForm(
				{ FirstName: firstName, LastName: lastName, Organization: organization },
				(Errors) => {
					setErrors({ ...errors, ...Errors })
				}
			)
		) {
			setIsLoading(true)
			var formData = new FormData();
			formData.append("first_name", firstName.trim());
			formData.append("last_name", lastName.trim());
			formData.append("profile_image", file);
			formData.append("organization", organization);
			formData.append("role", Profile.RoleID.toString())
			formData.append("email", Profile.Email)
			ChannelUserService.updateProfile(Profile.ID, formData)
				.then((res) => {
					setIsLoading(false)
					setToast(ToasterTexts.PROFILE_EDIT_SUCCESS, ToasterType.SUCCESS);
					handleCloseEditProfile(true)
				})
				.catch((err) => setIsLoading(false))
			if (!OnboardingDetails.CheckPoints.find(x => x.Title === "Fill in your profile details").Status) {
				ChannelUserService.updateOnBoardingDetails({ orgId: ChannelUserService.getCurrentUserFromLocalStorage().OrganizationID, onboardingStatus: OnboardingDetails.OnboardingStatus, checkpoints: OnboardingDetails.CheckPoints.map(x => { return { title: x.Title, status: x.Title === "Fill in your profile details" ? true : x.Status } }) }).then((res) => {
					dispatch(updateOnBoardingDetails(mapToOnboardingDetailsModel(res.data)))
				})
			}
		} else {
		}
	}


	return (
		<div className={`${IsMobileDevice ? 'w-p-100 h-p-100 d-flex flex-direction justify-center' : 'w-p-100 h-p-100 d-flex w-p-98 mx-auto justify-center align-center'}  bg-color-profile-primary-background`}>
			{IsMobileDevice && <> {showEditProfile ? <div className='bg-transparent d-flex w-fill p-1 mt-1'>
				<span><BackMobileIcon className={"c-pointer pr-2"} onClick={() => handleCloseEditProfile(false)} /></span>
				<span className={`h3-semibold d-inline-flex color-primary-accent mr-auto`}>{pageTitles.EDIT_PROFILE}</span>
			</div> :
				<div className="mx-1 mt-1">
					<PageHeader
						HeaderText={pageTitles.PROFILE}
						HideSearch={true}
						ShowFilterIcon={false} />
				</div>}
			</>}
			<div className={`w-p-100 h-p-100 ${IsMobileDevice ? "o-y-scroll" : "d-flex justify-center align-center"}`}>
				<div className={`bg-color-secondary profile-border br-3 ${IsMobileDevice ? "mx-2 mt-1 mx-auto h-p-26 min-h-24 mb-2 d-flex flex-direction justify-center" : " w-p-20 h-p-60 mr-2 min-w-30 max-w-30 d-flex flex-direction justify-center align-center"}`}>
					<div className="w-p-100 d-flex align-center justify-flex-end flex-direction p-relative">
						{(image) ?
							<Avatar
								Name={Profile.FullName}
								Size={IsMobileDevice ? 88 : 140}
								ImgSrc={image}
							/>
							:
							<Avatar
								Name={Profile.FullName}
								Size={IsMobileDevice ? 88 : 140}
							/>
						}
						{IsMobileDevice && !showEditProfile && <ButtonComponent
							buttonProps={{ tabIndex: 3 }}
							Variant={
								LoadingProfile ? "disabled-btn" : "primary-btn"
							}
							ClassName={`c-pointer color-profile-changepassword-box-border primary-btn d-flex p-absolute r-2 t-0`}
							OnClick={handleOpenEditProfile}
							Icon={EditProfileIcon}
							ButtonLabel=""
						/>}
						{showEditProfile && <>
							<Badge
								badgeContent={
									<button
										tabIndex={3}
										className=""
										onClick={handleClickmenu}
									>
										<ProfileCameraIcon role="button" />
									</button>
								}
								anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
								classes={{ anchorOriginBottomRightRectangular: `${IsMobileDevice ? "b-1 l-1" : "b-2 l-4"} ` }}
							></Badge>
							<Menu
								// getContentAnchorEl={null}
								id="simple-menu"
								anchorEl={anchorEl}
								open={Boolean(anchorEl)}
								onClose={handleClosemenu}
								PaperProps={{
									className: "box-shadow-none"
								}}
							>
								<MenuItem
									className={"c-pointer"}
									classes={{ root: "m-menuitem-min-height" }}
								>
									<span
										className={`color-profile-profile-heading ${IsMobileDevice ? "h2" : "h4-regular"
											}`}
									>
										{!image ?
											<UploadIcon className={"mr-1"} />
											:
											<ChangeProfileIcon className={"mr-1"} />}
									</span>
									<span
										className={`color-profile-profile-heading ${IsMobileDevice ? "h2" : "h4-regular"
											}`}
									>
										<label htmlFor={"Upload" + imageReferenceId}>
											<span className={"h4-regular color-menu-list-font-color c-pointer"}> {!image
												? ActionLabels.UPLOAD_PHOTO
												: ActionLabels.CHANGE_PHOTO}</span>
										</label>
										<input
											id={"Upload" + imageReferenceId}
											accept="image/*"
											className={"d-none"}
											multiple
											type="file"
											onChange={onImagechange}
											ref={fileInputRef}
										/>
									</span>
								</MenuItem>
								<MenuItem
									onClick={onRemovephoto}
									classes={{ root: `${IsMobileDevice && "minh-0"}` }}
									className={`${!image ? "disabled" : "c-pointer"}`}
								>
									<span
										className={`${!image ? `disabled  ${IsMobileDevice ? "h2" : "h4-regular"}`
											: `color-profile-profile-heading  ${IsMobileDevice ? "h2" : "h4-regular"}`}`} >
										{!image ?
											<RemovePhotoIcon className={"mr-1"} /> : <RemoveIcon className={"mr-1"} />
										}
									</span>
									<span
										className={`${!image ? `disabled color-secondary-light ${IsMobileDevice ? "h2" : "h4-regular"}`
											: `color-profile-profile-heading  ${IsMobileDevice ? "h2" : "h4-regular"}`}`}>
										{ActionLabels.REMOVE_PHOTO}
									</span>
								</MenuItem>
							</Menu>
						</>
						}
						<div className="w-p-100 h-3 color-primary-danger h6-medium d-flex justify-center align-center">{hasError}</div>
					</div>
					<div className="w-p-100 h-p-20 d-flex flex-direction justify-center align-center">
						<div className="h2-medium color-login-title t-align-center flex-wrap">
							{trimMessage(Profile.FullName, 20)}
						</div>
						<div className="h5-medium color-login-subtitle">
							{Profile.OrganizationName}
						</div>
					</div>
				</div>
				<div className={`bg-color-secondary profile-border br-3 ${IsMobileDevice ? "mx-2 mb-4" : "w-p-50 h-p-60 min-w-57 max-w-72 o-y-hidden d-flex flex-direction"}`}>
					{!IsMobileDevice && <div className="h-9 profile-divider d-flex justify-between color-login-subtitle px-4">
						<div className="h2-semibold mr-auto h-p-100 d-flex align-center">
							Profile Details
						</div>
						<div className="ml-auto h-p-100 d-flex align-center profile-tutorial">
							{!showEditProfile ? <ButtonComponent
								buttonProps={{ tabIndex: 3 }}
								Variant={
									LoadingProfile ? "disabled-btn" : "primary-btn"
								}
								ClassName={`c-pointer color-profile-changepassword-box-border primary-btn d-flex ml-auto ${IsMobileDevice ? "h2 mx-auto mt-1" : "h5-regular"
									}`}
								OnClick={handleOpenEditProfile}
								Icon={EditProfileIcon}
								ButtonLabel="Edit Profile"
							/>
								:
								<>
									<ButtonComponent
										buttonProps={{ tabIndex: 7 }}
										Variant="secondary-btn-small"
										ClassName={`c-pointer  mr-1`}
										OnClick={() => handleCloseEditProfile(false)}
										ButtonLabel="Cancel"
									/>
									<ButtonComponent
										buttonProps={{ tabIndex: 6 }}
										Variant={!(errors.FirstName || errors.LastName || hasError.length !== 0) ? "primary-btn-small" : "disabled-btn-small"}
										ClassName={`c-pointer w-space px-4`}
										Type={"submit"}
										ButtonLabel="Save"
										Loading={isLoading}
										OnClick={onSubmit}
									/>
								</>
							}
						</div>
					</div>
					}
					<div className="w-p-100 h-p-100">
						<div className={` d-flex  ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center h-5 mt-2 pl-4"}`}>
							<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h5-medium color-profile-name-field`}>
								First Name
							</div>
							<div className={` ${IsMobileDevice ? "w-p-95 h-5 d-flex align-center h3-medium" : "w-p-50 h4-medium"} color-login-subtitle`}>
								{showEditProfile ?
									<>
										<TextField
											autoFocus
											fullWidth
											name="FirstName"
											placeholder="First Name"
											size="small"
											variant="outlined"
											InputProps={{
												classes: {
													input: `profile-edit-input color-profile-textfield-content ${IsMobileDevice ? "h3-medium" : 'h4-regular'}`,
												},
											}}
											className="br-2 my-auto"
											onChange={(e) => { handleChange(e.target.name, e.target.value); setFirstName(e.target.value) }
											}
											defaultValue={firstName}
											inputProps={{ tabIndex: 4 }}
										/>
									</> :
									<div className="br-2 h-p-100 d-flex align-center"> {Profile.FirstName} </div>
								}
							</div>
							{
								IsMobileDevice && <FormHelperText className=" footnote color-primary-danger t-align-right ml-auto pr-3">
									{errors.FirstName}
								</FormHelperText>
							}
						</div>
						{!IsMobileDevice && <div className={` d-flex  ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center pl-4 h-2"}`}>
							<div className={` ${IsMobileDevice ? "w-p-100 h-2 d-flex align-end" : "w-p-30"} h5-medium color-profile-name-field`}>
							</div>
							<div className={` ${IsMobileDevice ? "w-p-95 h-3 d-flex align-center" : "w-p-50"} color-login-subtitle h4-medium`}>
								<FormHelperText className=" footnote color-primary-danger t-align-right">
									{errors.FirstName}
								</FormHelperText>
							</div>
						</div>
						}
						<div className={` d-flex ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center mt-1 h-5 pl-4"}`}>
							<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h5-medium color-profile-name-field`}>
								Last Name
							</div>
							<div className={` ${IsMobileDevice ? "w-p-95 h-5 d-flex align-center h3-medium" : "w-p-50 h4-medium"} color-login-subtitle`}>
								{showEditProfile ?
									<>
										<TextField
											fullWidth
											name="LastName"
											placeholder="Last Name"
											size="small"
											variant="outlined"
											InputProps={{
												classes: {
													input: `profile-edit-input color-profile-textfield-content ${IsMobileDevice ? "h3-medium" : 'h4-regular'}`,
												},
											}}
											className="br-2 my-auto"
											onChange={(e) => { handleChange(e.target.name, e.target.value); setLastName(e.target.value) }
											}
											defaultValue={lastName}
											inputProps={{ tabIndex: 4 }}
										/>
									</> :
									<div className="br-2 h-p-100 d-flex align-center"> {Profile.LastName} </div>
								}
							</div>
							{
								IsMobileDevice && <FormHelperText className=" footnote color-primary-danger t-align-right ml-auto pr-3">
									{errors.LastName}
								</FormHelperText>
							}
						</div>
						{!IsMobileDevice && <div className={` d-flex  ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center pl-4 h-2"}`}>
							<div className={` ${IsMobileDevice ? "w-p-100 h-2 d-flex align-end" : "w-p-30"} h5-medium color-profile-name-field`}>
							</div>
							<div className={` ${IsMobileDevice ? "w-p-95 h-3 d-flex align-center" : "w-p-50"} color-login-subtitle h4-medium`}>
								<FormHelperText className=" footnote color-primary-danger t-align-right">
									{errors.LastName}
								</FormHelperText>
							</div>
						</div>
						}
						<div className={` d-flex ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center h-5 pl-4 mb-2"}`}>
							<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h5-medium color-profile-name-field`}>
								Email
							</div>
							<div className={` ${IsMobileDevice ? "w-p-100 h-5 d-flex align-center mb-1 h3-medium" : "w-p-50 h4-medium"} color-login-subtitle `}>
								{Profile.Email}
							</div>
						</div>
						<div className={` d-flex ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center h-5 pl-4"}`}>
							<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h5-medium color-profile-name-field`}>
								Organization Name
							</div>
							<div className={` ${IsMobileDevice ? "w-p-95 h-5 d-flex align-center h3-medium" : "w-p-50 h4-medium"} color-login-subtitle`}>
								{(Profile.RoleID === Role.ORGANIZATION_ADMIN && showEditProfile) ?
									<>
										<TextField
											fullWidth
											name="Organization"
											placeholder="Organization Name"
											size="small"
											variant="outlined"
											InputProps={{
												classes: {
													input: `profile-edit-input color-profile-textfield-content ${IsMobileDevice ? "h3-medium" : 'h4-regular'}`,
												},
											}}
											className="my-auto br-2"
											onChange={(e) => { handleChange(e.target.name, e.target.value); setOrganization(e.target.value) }
											}
											defaultValue={organization}
											inputProps={{ tabIndex: 4 }}
										/>
									</> :
									<div className="br-2 h-p-100 d-flex align-center"> {Profile.OrganizationName} </div>
								}
							</div>
							{
								IsMobileDevice && <FormHelperText className=" footnote color-primary-danger t-align-right ml-auto pr-3">
									{errors.Organization}
								</FormHelperText>
							}
						</div>
						{!IsMobileDevice && <div className={` d-flex  ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center pl-4 h-2"}`}>
							<div className={` ${IsMobileDevice ? "w-p-100 h-2 d-flex align-end" : "w-p-30"} h5-medium color-profile-name-field`}>
							</div>
							<div className={` ${IsMobileDevice ? "w-p-95 h-3 d-flex align-center" : "w-p-50"} color-login-subtitle h4-medium`}>
								<FormHelperText className=" footnote color-primary-danger t-align-right">
									{errors.Organization}
								</FormHelperText>
							</div>
						</div>
						}
						<div className={` d-flex ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center h-5 mb-2 pl-4"}`}>
							<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h5-medium color-profile-name-field`}>
								Role
							</div>
							<div className={` ${IsMobileDevice ? "w-p-100 h-5 d-flex align-center mb-1 h3-medium" : "w-p-50 h4-medium"} color-login-subtitle `}>
								{Profile.RoleID === Role.SYSTEM_ADMIN ? RolesLabel.SYSTEM_ADMIN : Profile.RoleID === Role.ORGANIZATION_ADMIN ? RolesLabel.ORGANIZATION_ADMIN : RolesLabel.USER}
							</div>
						</div>
					</div>
				</div>
				{(IsMobileDevice && showEditProfile) &&
					<div className="w-p-90 d-flex justify-between mx-auto pb-6">
						<ButtonComponent
							buttonProps={{ tabIndex: 7 }}
							Variant="secondary-btn-small"
							ClassName={`c-pointer mr-2 w-p-45`}
							OnClick={() => handleCloseEditProfile(false)}
							ButtonLabel="Cancel"
						/>
						<ButtonComponent
							buttonProps={{ tabIndex: 6 }}
							Variant={!(errors.FirstName || errors.LastName || hasError.length !== 0) ? "primary-btn-small" : "disabled-btn-small"}
							ClassName={`c-pointer w-space w-p-45`}
							Type={"submit"}
							ButtonLabel="Save"
							Loading={isLoading}
							OnClick={onSubmit}
						/>
					</div>
				}
			</div>
		</div>
	);
}

export default ProfileComponent;
